import { Box } from "@chakra-ui/react";

export const AIRDROP_VAULT_STRINGS = {
  HEADER: {
    TITLE: "Airdrop Gain Vault",
    STATS: {
      TVL: "Vault TVL",
      APY: "Estimated APR",
    },
  },
  ASSETS_ACCEPTED: {
    heading: "Assets accepted",
    list: [
      {
        key: "eth",
        title: "ETH",
        iconKey: "/assets/eth_blue.png",
      },
      {
        key: "rsETH",
        title: "rsETH",
        iconKey: "/assets/rseth.png",
      },
      {
        key: "stETH",
        title: "stETH",
        iconKey: "/assets/stETH.svg",
      },
      {
        key: "ethx",
        title: "ETHx",
        iconKey: "/assets/ethx.svg",
      },
    ],
  },
  SECTIONS: {
    DEPOSIT_WITHDRAW: {
      TABS: [
        { key: "deposit", title: "Deposit" },
        { key: "withdraw", title: "Withdraw" },
        { key: "bridge", title: "Bridge" },
      ],
      DISCLAIMER: {
        DEPOSIT: "",
        WITHDRAW: (
          <>
            The withdrawal amount will be{" "}
            <Box as="span" fontWeight="500" color="textPrimary">
              auto-claimed
            </Box>{" "}
            to your address in 3-4 days once you request a withdrawal. Check
            pending claims in the &apos;Claims&apos; section. While in the
            withdrawal queue, you will not earn any position rewards or points.
            All your withdrawals in a day will be fulfilled as a single
            transaction.
          </>
        ),
      },
      BRIDGE: {
        heading: "You can bridge your agETH to 3 active L2s.",
        supported: [
          {
            chain: "Ethereum",
            icon: "/assets/eth.svg",
          },
          {
            chain: "Arbitrum One",
            icon: "/assets/bridge/arbitrum.svg",
          },
          {
            chain: "Linea",
            icon: "/assets/chains/linea.svg",
          },
          {
            chain: "Scroll",
            icon: "/assets/chains/scroll.svg",
          },
        ],
      },
    },
    PORTFOLIO: {
      TABS: [
        { key: "overview", title: "Overview" },
        { key: "apr_reports", title: "Strategy Reports", isNew: true },
        { key: "holdings", title: "My Holdings" },
      ],
      HOLDINGS: {
        walletConnect: "Connect your wallet to view your holdings",
        nexusMutual: {
          title:
            "Insure your hgETH with Nexus Mutual. 10% discount for Gain users.",
          CTA: "Get insurance",
          imgSrc: "/assets/vaults/nexus.svg",
        },
      },
      POINTS: {
        walletConnect: "Connect wallet to view your points",
        supported: [
          {
            key: "zircuitPoints",
            title: "Zircuit",
            tag: "Boosted",
            logo: "/assets/platforms/zircuit.svg",
          },
          {
            key: "linea",
            title: "Linea",
            tag: "Boosted",
            logo: "/assets/chains/linea.svg",
          },
          {
            key: "scroll",
            title: "Scroll",
            tag: "Top Marks",
            logo: "/assets/chains/scroll.svg",
          },
          {
            key: "infra",
            title: "Infra Partner Points",
            tag: "3x",
            logo: "/assets/vaults/infra.svg",
            isComingSoon: true,
          },
          {
            key: "karak",
            title: "Karak",
            tag: "Boosted",
            logo: "/assets/vaults/karak.svg",
          },
          {
            key: "kernel",
            title: "Kernel Points",
            tag: "3x (Boosted)",
            logo: "/assets/kernel.svg",
          },
          {
            key: "eigen",
            title: "$Eigen Rewards",
            tag: "1x",
            logo: "/assets/eigen_round.svg",
            infoCTA: {
              label: "Auto-compounded",
              icon: "/assets/gain/autocomputed.svg",
              tooltipText:
                "Eigen rewards will reflect as an increase in the exchange rate of agETH with respect to the underlying assets.",
            },
          },
        ],
      },
      CLAIMS: {
        walletConnect: "Connect wallet to view your claims",
        noData: "No claims data available",
        COLUMNS: ["Asset", "Amount", "Status"],
      },
      HISTORY: {
        walletConnect: "Connect wallet to view your history",
        COLUMNS: ["Date", "Time", "Transaction", "Asset", "Amount", "Status"],
      },
      APR_REPORTS: {
        walletConnect: "Connect wallet to view your history",
        cmsKey: "airdrop_vault",
        COLUMNS: [
          {
            name: "Strategy",
            key: "strategy_name",
            hasImage: true,
          },
          {
            name: "Allocation %",
            isNumeric: true,
            key: "allocation",
          },
          {
            name: "APR",
            isNumeric: true,
            key: "apr",
          },
          {
            name: "APR on allocation",
            isNumeric: true,
            key: "apr_on_allocation",
          },
        ],
      },
    },
    OVERVIEW: {
      TABS: [
        { key: "overview", title: "Overview" },
        { key: "strategies", title: "Strategies" },
      ],
      DATA: {
        MAIN: {
          heading: "Maximizes your airdrops",
          headingIcon: "/assets/vaults/agETHOverview.png",
          desc: "Deposit ETH, rsETH, or LSTs to farm airdrops and earn rewards from L2s, DeFi, Kelp, and EigenLayer. Get agETH and boost rewards further through DeFi.",
          disclaimerLink:
            "https://docs.google.com/document/d/1KnAvqWDWXr-GpU3c1g_CtQU6y1fpxX9oaGRcrx4lcWQ",
        },
        FEES: {
          heading: "Fees & Details",
          data: [
            {
              key: "annual",
              title: "Annual fee",
              value: "2%",
              tooltip: "2% per annum is the platform fees charged",
            },
            {
              key: "contract",
              title: "Link to contract",
              value: "0xe1B4d3...",
              link: "https://etherscan.io/address/0xe1B4d34E8754600962Cd944B535180Bd758E6c2e",
            },
          ],
        },
        ASSETS: {
          heading: "Assets accepted",
          list: [
            {
              key: "eth",
              title: "ETH",
              iconKey: "/assets/eth_blue.png",
            },
            {
              key: "rsETH",
              title: "rsETH",
              iconKey: "/assets/rseth.png",
            },
            {
              key: "stETH",
              title: "stETH",
              iconKey: "/assets/stETH.svg",
            },
            {
              key: "ethx",
              title: "ETHx",
              iconKey: "/assets/ethx.svg",
            },
          ],
        },
        PARTNERS: {
          heading: "Vault Partners",
          details: [
            {
              key: "k3-capital",
              imgSrc: "/assets/partners/k3capital.svg",
              link: "https://kerneldao.gitbook.io/kernel/getting-started/gain/airdrop-gain#vault-partners",
              imageWidth: 50,
            },
            {
              key: "august",
              imgSrc: "/assets/partners/august.svg",
              link: "https://kerneldao.gitbook.io/kernel/getting-started/gain/airdrop-gain#vault-partners",
              imageWidth: 90,
            },
          ],
        },
      },
      STRATEGIES: {
        COLUMNS: [
          {
            label: "Strategy",
            accessor: "strategy",
          },
          {
            label: "Allocation %",
            accessor: "allocation",
          },
        ],
      },
      RESERVES: {
        COLUMNS: ["Date", "Time", "Block", "Asset", "Amount", "Txn"],
      },
    },
  },
};
